<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faHospital } from '@fortawesome/pro-light-svg-icons';
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import WelcomeDetails from '$lib/WelcomeDetails.svelte';
  import { user, isAuthenticated, setSession } from '$stores/sessionStore';
  import { selectedStudy, selectedSite } from '$stores/selectionStore';
  import { page } from '$stores/pageStore';
  import { studies, sites } from '$lib/api';
  import { navigate as goto } from 'svelte-routing';

  // Send the user to their natural landing page based on assignments.
  // Parity with legacy: admin (no studies) -> /studies, study user -> /sites,
  // site user -> /persons. Without this, post-login lands on /dashboard which
  // breaks parity with legacy where landing on /studies was the norm.
  //
  // SPTL-486 (round 2): decouple the landing route from the study/site lookup
  // succeeding. Site users MUST land on /persons even if the pre-fetch of
  // selectedStudy/selectedSite errors — otherwise they get bounced to /sites
  // (which they have no permission to browse) or /studies (empty grid).
  // The pre-fetch is now a best-effort optimisation, not a gate.
  async function landingFor(userData) {
    const studyIds = userData?.studyIds || [];
    const siteIds = userData?.siteIds || [];

    // Site user — has siteIds. Always land on /persons.
    if (siteIds.length > 0) {
      if (studyIds.length > 0) {
        try {
          const study = await studies.byProtocol(studyIds[0]);
          selectedStudy.set(study);
          try {
            const siteResponseData = await sites.byId({ siteId: siteIds[0], studyGUID: study._id });
            const site = siteResponseData?.data || siteResponseData;
            if (site) selectedSite.set(site);
          } catch (_) { /* best-effort */ }
        } catch (_) { /* best-effort */ }
      }
      goto('/persons');
      return;
    }

    // Study user — has studyIds, no siteIds. Land on /sites.
    if (studyIds.length > 0) {
      try {
        const study = await studies.byProtocol(studyIds[0]);
        selectedStudy.set(study);
      } catch (_) { /* best-effort */ }
      goto('/sites');
      return;
    }

    // Admin / unassigned — /studies.
    goto('/studies');
  }

  onMount(async () => {
    const url = $page.url;
    const userDataParam = url.searchParams.get('userData');

    if (userDataParam) {
      try {
        const userData = JSON.parse(decodeURIComponent(userDataParam));
        setSession(userData);

        // Strip userData from URL to avoid exposing sensitive data on refresh.
        const cleanUrl = new URL(url.href);
        cleanUrl.searchParams.delete('userData');
        window.history.replaceState({}, document.title, cleanUrl.pathname);

        await landingFor(userData);
        return;
      } catch (error) {
        console.error('Error processing user data from URL:', error);
        goto('/login?error=invalid_user_data');
        return;
      }
    }

    const authenticated = get(isAuthenticated);
    if (authenticated) {
      await landingFor(get(user));
    } else {
      goto('/login');
    }
  });
</script>

<WelcomeDetails />


